const TripleProgressLineFlex = ({ site, total, entered, opened, signed }) => {
  const scale = total > 0 ? total : 1;

  const getPercentage = (value) => {
    if (total === 0) return 0;
    return ((value / total) * 100).toFixed(1);
  };

  const allValuesZero = entered === 0 && opened === 0 && signed === 0;

  return (
    <div className="mb-4">
      <div className="flex justify-between text-sm mb-1 h-[30px] font-semibold">
        <span>{site}</span>
        <span>Total Cases: {total}</span>
      </div>
      {/* Progress bar container */}
      <div className="flex h-[30px] w-full rounded overflow-hidden bg-[#555]">
        {allValuesZero ? (
          <div className="bg-[#555] w-full" />
        ) : (
          <>
            <div
              className={entered === 0 ? "bg-[#555]" : "bg-[#5A3EFF]"}
              style={{ width: `${(entered / scale) * 100}%` }}
            />
            <div
              className={opened === 0 ? "bg-[#555]" : "bg-[#00A3FF]"}
              style={{ width: `${(opened / scale) * 100}%` }}
            />
            <div
              className={signed === 0 ? "bg-[#555]" : "bg-[#9747FF]"}
              style={{ width: `${(signed / scale) * 100}%` }}
            />
          </>
        )}
      </div>
      {/* Legend below */}
      <div className="flex gap-5 mt-5 text-sm">
        <div>
          <div className="flex items-center gap-2 h-[30px]">
            <span
              className={`w-3 h-3 block rounded-full ${
                entered === 0 ? "bg-[#555]" : "bg-[#5A3EFF]"
              }`}></span>
            Entered
          </div>
          <div className="ml-5 h-[30px] flex">
            {getPercentage(entered)}% - {entered}
          </div>
        </div>
        <div>
          <div className="flex items-center gap-2 h-[30px]">
            <span
              className={`w-3 h-3 block rounded-full ${
                opened === 0 ? "bg-[#555]" : "bg-[#00A3FF]"
              }`}></span>
            Opened
          </div>
          <div className="ml-5 h-[30px] flex">
            {getPercentage(opened)}% - {opened}
          </div>
        </div>
        <div>
          <div className="flex items-center gap-2 h-[30px]">
            <span
              className={`w-3 h-3 block rounded-full ${
                signed === 0 ? "bg-[#555]" : "bg-[#9747FF]"
              }`}></span>
            Signed
          </div>
          <div className="ml-5 h-[30px] flex">
            {getPercentage(signed)}% - {signed}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TripleProgressLineFlex;
